import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationStart, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { routePath } from 'src/app/app-routing.module';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsComponent implements OnInit, OnDestroy {
  isQuotationTab: boolean = true;
  isCustomerInfoTab: boolean = false;

  private routeSubscription: Subscription;

  constructor(private router: Router, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.onRouteChange();
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

  onRouteChange(): void {
    this.routeSubscription = this.router.events
      .pipe(filter((event: RouterEvent) => event instanceof NavigationStart))
      .subscribe((routeEvent: RouterEvent) => {
        if (routeEvent.url === `/${routePath.QUOTATION}`) {
          this.isQuotationTab = true;
          this.isCustomerInfoTab = false;
        } else if (routeEvent.url === `/${routePath.CUSTOMERINFO}`) {
          this.isQuotationTab = true;
          this.isCustomerInfoTab = true;
        } else {
          this.isQuotationTab = false;
          this.isCustomerInfoTab = false;
        }

        this.cdr.detectChanges();
      });
  }
}
